import PageHeader from 'components/PageHeader'
import AdGroupCopyHistory from './adGroupCopy/AdGroupCopyHistory'
import Upload from 'features/bulk/upload/Upload'
import Download from 'features/bulk/download/Download'
import Tab from 'components/Tab'
import KeywordUpload from 'features/bulk/keywordPlanner/KeywordUpload'

const Bulk = () => (
  <div className="filemanage_wrap">
    <div className="dsp_tit">
      <PageHeader pageTitle="대량 관리" />
    </div>
    <strong className="screen_out">대량관리 메뉴 탭</strong>
    <Tab.Group>
      <Tab path="download" title="다운로드">
        <Download />
      </Tab>
      <Tab path="upload" title="업로드">
        <Upload />
      </Tab>
      <Tab path="group-copy" title="광고그룹 복사 현황">
        <AdGroupCopyHistory />
      </Tab>
      <Tab path="keyword-planner" title="키워드 플래너">
        <KeywordUpload />
      </Tab>
    </Tab.Group>
  </div>
)

export default Bulk
